import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_PROJECT_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

const redirectUrl = 'https://thebooth.gg' || 'http://localhost:3000';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper function to resend email verification
export async function startEmailVerification(email) {
  const { data, error } = await supabase.auth.resend({
    type: 'signup',
    email: email,
    options: {
      emailRedirectTo: `${redirectUrl}/verifyEmail`
    }
  });
  if (error) throw error;
  return data;
}

// Helper function to recover password
export async function recoverPassword(email) {
  const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${window.location.origin}/resetPassword`,
  });
  if (error) throw error;
  return data;
}
